// Thin bridge so widget files keep their Vue-2-style `{ el, data: {...}, methods, ... }`
// option shape after the Vue 3 migration. Vue 3 removed the `el` option (mount target is
// a separate `.mount(selector)` call) and requires `data` to be a factory function.
import { createApp } from 'vue';

export function createVueInstance(options) {
	const { el, data, ...rest } = options;
	if (data && typeof data !== 'function') {
		rest.data = () => ({ ...data });
	} else if (data) {
		rest.data = data;
	}
	return createApp(rest).mount(el);
}
